const url =
  process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_MANOKIP_API_URL
    : 'https://manometr.uz/api';

export default url;
